import { useSyncExternalStore } from "react";

let epoch = 0;
const listeners = new Set<() => void>();

export function incrementLiveUpdateMvtEpoch(): void {
	epoch += 1;
	for (const listener of listeners) listener();
}

export function getLiveUpdateMvtEpoch(): number {
	return epoch;
}

export function useLiveUpdateMvtEpoch(): number {
	return useSyncExternalStore(
		(listener) => {
			listeners.add(listener);
			return () => listeners.delete(listener);
		},
		getLiveUpdateMvtEpoch,
		getLiveUpdateMvtEpoch,
	);
}
